// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_0wn","cls2":"ResearchInterestsCard-cls2_pAb ResearchInterestsCard-cls1_0wn"};